/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Confirmed/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import Content from './Content/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Confirmed({
  children,
  viewPath = "/DesignSystem/AppointmentBookingStateTextWithIcon/Confirmed",
  size
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'Content'
let selectedConfirmationStatusValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'confirmation_status',
})
let constantData = 'CONFIRMED'
let aggregateData = fromAggregate.equals(selectedConfirmationStatusValueData, constantData)
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: Boolean(aggregateData),
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'Content'}>
<Content
  viewPath={`${viewPath}/Content`}
 size={size}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}